import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AlertService } from './alerts/alert.service';
import { LegacyService } from '../legacy/legacy.service';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Menu } from '@store/models';
import { catchError, map } from 'rxjs/operators';
import { AlertType } from './alerts/alert.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {

    constructor(
        private alert: AlertService,
        private legacyService: LegacyService,
        private router: Router,
        private http: HttpClient
    ) {
    }

    getBaseMenu(): Observable<Menu[]> {
        // TODO: research better way to do this
        return this.http.get<Menu[]>('assets/header-menu.json').pipe(
            map(menuObj => {
                menuObj.map(menu => {
                    if (menu.url && environment.production) { menu.url = menu.url.replace(':8003', ':81'); }
                    if (menu.items && environment.production) { menu.items.map(menuItem => {
                        if (menuItem.url) { menuItem.url = menuItem.url.replace(':8003', ':81'); }
                    }); }
                });
                return menuObj;
            }),
            catchError(this.handleError('Kan ikke hente basis menu', 'danger', []))
        );
    }

    private handleError<T> (message: string, type: AlertType, result?: T) {
        return (): Observable<T> => {
            this.alert.createAlert(message, type);
            return of(result as T);
        };
    }

    async openCase(kid: string, sagId: string, v2RegnskabsaarKundeId: number, yid: number) {
        if (kid === '') {
            this.alert.createAlert('Der opstod en fejl med kundenummeret for sagen', 'danger');
            return;
        }
        if (v2RegnskabsaarKundeId) {
            await this.router.navigate([
                'clients', kid, 'udfoer', 'regnskabsaar', v2RegnskabsaarKundeId, 'sag', sagId
            ]);
            return;
        }
        let lnk = 'kundeskema/Kundeskema_frame.asp';
        if (yid === 7) {
            lnk = 'kundeskema/Advice.asp';
        }
        const url = `${environment.legacyUrl}/timesag/${lnk}?ID=${kid}&SAG=${sagId}`;
        const windowParams = `scrollbars,resizable, width=${screen.availWidth},height=${screen.availHeight},top=0, left=0`;
        this.legacyService.navigate(url, '', windowParams);
    }
}
